<template>
  <g fill="currentColor">
    <!-- Top-left finder pattern -->
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect
      x="4.5"
      y="4.5"
      width="4"
      height="4"
      rx="0.5"
      fill="var(--spark-icon-bg, white)"
    />
    <rect x="5.5" y="5.5" width="2" height="2" />
    <!-- Top-right finder pattern -->
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect
      x="15.5"
      y="4.5"
      width="4"
      height="4"
      rx="0.5"
      fill="var(--spark-icon-bg, white)"
    />
    <rect x="16.5" y="5.5" width="2" height="2" />
    <!-- Bottom-left finder pattern -->
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect
      x="4.5"
      y="15.5"
      width="4"
      height="4"
      rx="0.5"
      fill="var(--spark-icon-bg, white)"
    />
    <rect x="5.5" y="16.5" width="2" height="2" />
    <!-- Data modules (bottom-right quadrant) -->
    <rect x="14" y="14" width="2" height="2" />
    <rect x="17" y="14" width="2" height="2" />
    <rect x="14" y="17" width="2" height="2" />
    <rect x="17" y="17" width="2" height="2" />
    <rect x="20" y="14" width="1" height="1" />
    <rect x="14" y="20" width="1" height="1" />
    <rect x="20" y="20" width="1" height="1" />
  </g>
</template>
